import { useCreateMedication } from './hooks/useCreateMedication'
import { MedicationFormPage } from './components/MedicationForm/MedicationFormPage'
import type { MedicationFormValues } from './types'

export function AddMedicationPage() {
  const { mutateAsync, isPending } = useCreateMedication()

  async function handleSubmit(values: MedicationFormValues) {
    const id = await mutateAsync(values)
    return id
  }

  return (
    <MedicationFormPage mode='add' successMessage='Medication added!' onSubmit={handleSubmit} isPending={isPending} />
  )
}
